import { render, staticRenderFns } from "./Sftp.vue?vue&type=template&id=c529c8e8&scoped=true&"
import script from "./Sftp.vue?vue&type=script&lang=js&"
export * from "./Sftp.vue?vue&type=script&lang=js&"
import style0 from "./Sftp.vue?vue&type=style&index=0&id=c529c8e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c529c8e8",
  null
  
)

export default component.exports